import { config } from '../main.js';
import { ctx } from '../canvas.js';
import * as mouse from '../mouse.js';
import * as compass from './compass.js';
import { dirToRad, degToRad } from '../utils.js';

export {
    init,
    draw,
}

function init() {
    // Add mode toggle clickable area
    mouse.addClickableArea({
        x: config.width - 45,
        y: 15,
        width: 30,
        height: 30,
        action: () => {
            compass.toggleMode();
        },
    });
}

function draw() {
    // Draw mode toggle circle
    ctx.strokeStyle = '#666';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(config.width - 30, 30, 15, 0, Math.PI * 2);
    ctx.stroke();
    
    ctx.fillStyle = '#ccc';
    if (compass.getMode() === 'heading-up') {
        // Draw heading icon
        ctx.beginPath();
        ctx.arc(config.width - 30, 42, 8, dirToRad(0) - degToRad(45), dirToRad(0) + degToRad(45));
        ctx.lineTo(
            config.width - 30,
            22
        );
        ctx.closePath();
        ctx.fill();
    } else {
        // Draw up indicator
        ctx.beginPath();
        ctx.moveTo(config.width - 26, 23);
        ctx.lineTo(config.width - 30, 19);
        ctx.lineTo(config.width - 34, 23);
        ctx.fill();

        // Draw north letter
        ctx.font = '14px Helvetica Neue';
        ctx.fillText(
            'N',
            config.width - 35,
            37
        );
    }
}